const BASE = (process.env.REACT_APP_PUBLIC_BASE_URL || "https://getmetworthapp.com").replace(/\/+$/, "");

// Single source of the public profile URL. Slug source: public_profiles.slug
// (the card editor keeps it equal to the primary digital_cards.slug).
export const getCanonicalProfileUrl = (slug) => (slug ? `${BASE}/${slug}` : null);

export const PUBLIC_BASE_URL = BASE;
